import * as React from "react";
const SvgIconCornerDownRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.5 8H5.25V1.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v7c0 .41.34.75.75.75h7c.41 0 .75-.34.75-.75S11.91 8 11.5 8", style: {
  fill: "currentColor"
} }));
export default SvgIconCornerDownRight;
